import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data_real"]

import {
  onMounted,
  ref,
  watchEffect,
  onUnmounted,
  computed,
} from "vue";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4chart from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import _ from "lodash";
import { userUseStore } from "@/store/user";
import { useOptionStore } from "@/store/option";
import { kgToPound } from "@/util/unit";


export default /*#__PURE__*/_defineComponent({
  props: {
  size: {
    type: String,
    default: () => "",
  },
  graph: {
    type: Array,
    default: () => [],
  },
  data_real: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props



const userStore = userUseStore();
const optionStore = useOptionStore();

const chartRef = ref<any>(null);

const graphData = ref(props.graph);

const chartData = computed(() => {
  return graphData.value.map((data: any) => {
    return {
      ...data,
      weight:
        optionStore.$state.unitSystem === "metric"
          ? data.weight
          : kgToPound(data.weight).toFixed(2),
    };
  });
});

watchEffect(() => {
  if (graphData.value.length >= userStore.CHART_COUNT) {
    graphData.value.shift();
  }

  graphData.value.push(props.data_real);
});

onMounted(() => {
  am4core.useTheme(am4themes_animated);
  const chart = am4core.create(chartRef.value, am4chart.XYChart);
  chart.data = props.graph;
  chart.zoomOutButton.disabled = true;
  chart.paddingRight = 40;

  chart.cursor = new am4chart.XYCursor();
  chart.cursor.lineX.disabled = true;
  chart.cursor.lineY.disabled = true;
  chart.cursor.behavior = "none";

  const xAxis = chart.xAxes.push(new am4chart.DateAxis());
  xAxis.baseInterval = {
    timeUnit: "second",
    count: 1,
  };
  xAxis.periodChangeDateFormats.setKey("minute", "[bold]h:mm");
  xAxis.periodChangeDateFormats.setKey("hour", "[bold]h:mm");
  xAxis.renderer.grid.template.disabled = true;
  xAxis.renderer.axisFills.template.disabled = true;
  xAxis.renderer.ticks.template.disabled = true;
  xAxis.renderer.minGridDistance = 60;
  xAxis.startLocation = 0.2;
  xAxis.endLocation = 0.8;
  xAxis.renderer.labels.template.fontWeight = "bold";
  xAxis.renderer.labels.template.fontSize = "12px";
  xAxis.renderer.labels.template.fill = am4core.color("#ffffff");
  xAxis.tooltipDateFormat = "hh:mm:ss";

  const yAxis = chart.yAxes.push(new am4chart.ValueAxis());
  // 무게의 그래프가 yAxis.max = 300; ?? 그 이상은 안되는 이유는??
  yAxis.max = 300;
  yAxis.min = 0;
  yAxis.renderer.grid.template.stroke = am4core.color("#ffffff");
  yAxis.renderer.grid.template.strokeWidth = 2;
  yAxis.renderer.labels.template.fontWeight = "bold";
  yAxis.renderer.labels.template.fontSize = "12px";
  yAxis.renderer.labels.template.fill = am4core.color("#ffffff");
  yAxis.cursorTooltipEnabled = false;

  const series = chart.series.push(new am4chart.LineSeries());
  series.dataFields.valueY = "weight";
  series.dataFields.dateX = "time";
  series.strokeWidth = 3;
  series.stroke = am4core.color("#348CD4");
  // series.tensionX = 0.8
  series.xAxis = xAxis;
  series.yAxis = yAxis;
  series.tooltipText = "[bold]{valueY} Kg[/]";

  const gradient = new am4core.LinearGradient();
  gradient.addColor(am4core.color("#348CD4"), 0.4);
  gradient.addColor(am4core.color("#348CD4"), 0);
  series.fill = gradient;
  series.fillOpacity = 1;

  const axisTooltip = xAxis.tooltip;
  if (axisTooltip) {
    axisTooltip.background.fill = am4core.color("#348CD4");
    axisTooltip.fontSize = 12;
    axisTooltip.background.strokeWidth = 0;
    axisTooltip.background.cornerRadius = 10;
    axisTooltip.background.pointerLength = 10;
    axisTooltip.dy = 1;
  }

  const dropShadow = new am4core.DropShadowFilter();
  dropShadow.dy = 2;
  dropShadow.dx = 2;
  dropShadow.opacity = 0.7;
  if (axisTooltip) {
    axisTooltip.filters.push(dropShadow);
  }

  watchEffect(() => {
    if (optionStore.$state.unitSystem === "metric") {
      series.tooltipText = "[bold]{valueY} Kg[/]";
      yAxis.max = 300;
    } else {
      series.tooltipText = "[bold]{valueY} lb[/]";
      yAxis.max = 600;
    }
  });

  watchEffect(() => {
    chart.data = chartData.value;

    // const maxData = computed(() => {
    // 	const maxWeight = _.maxBy(chart.data, 'weight')
    // 	if (maxWeight.weight === props.data_real.weight) {
    // 		const lastIdx = _.last(chart.data)
    // 		return lastIdx
    // 	} else {
    // 		return maxWeight
    // 	}
    // })

    // if (chart.data.length > 1) {
    // 	const maxDate = chart.xAxes.push(new am4chart.DateAxis())
    // 	maxDate.renderer.grid.template.location = 0
    // 	maxDate.renderer.minGridDistance = 150
    // 	maxDate.renderer.grid.template.disabled = true
    // 	maxDate.renderer.labels.template.disabled = true
    // 	maxDate.renderer.grid.template.stroke = am4core.color('#ffffff')
    // 	maxDate.renderer.grid.template.strokeWidth = 2

    // 	const maxValue = chart.yAxes.push(new am4chart.ValueAxis())
    // 	maxValue.renderer.opposite = true
    // 	maxValue.renderer.grid.template.disabled = true
    // 	maxValue.renderer.labels.template.disabled = true
    // 	maxValue.renderer.grid.template.stroke = am4core.color('#ffffff')
    // 	maxValue.renderer.grid.template.strokeWidth = 2

    // 	if (chart.series.length > 1) {
    // 		chart.series.pop()
    // 	}

    // 	const maxColumn = chart.series.push(new am4chart.ColumnSeries())
    // 	maxColumn.addData(maxData.value)
    // 	maxColumn.sequencedInterpolation = true
    // 	maxColumn.dataFields.valueY = `weight`
    // 	maxColumn.dataFields.dateX = `time`
    // 	maxColumn.fillOpacity = 0.2
    // 	maxColumn.strokeOpacity = 0.2
    // 	maxColumn.columns.template.width = 3
    // 	// maxColumn.columns.template.column.cornerRadiusTopRight = 10
    // 	// maxColumn.columns.template.column.cornerRadiusTopLeft = 10

    // 	const gradient = new am4core.LinearGradient()
    // 	gradient.addColor(am4core.color('#348CD4'), 0.5)
    // 	gradient.addColor(am4core.color('#FFFFFF'), 0.5)
    // 	gradient.rotation = 90
    // 	maxColumn.fill = gradient
    // 	maxColumn.stroke = gradient

    // 	// const bullet = maxColumn.bullets.create(am4chart.CircleBullet)
    // 	// bullet.fill = am4core.color('#ffffff')

    // 	// const labelBullet = maxColumn.bullets.push(new am4chart.LabelBullet())
    // 	// labelBullet.label.verticalCenter = 'top'
    // 	// labelBullet.dy = -35
    // 	// labelBullet.dx = 10
    // 	// labelBullet.label.text = '{valueY} kg'
    // 	// labelBullet.label.truncate = false
    // 	// labelBullet.label.fontSize = '0.8em'
    // 	// labelBullet.label.fill = am4core.color('#ffffff')
    // }
  });

  onUnmounted(async () => {
    chart.dispose();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(props.size),
    ref_key: "chartRef",
    ref: chartRef,
    data_real: props.data_real
  }, null, 12, _hoisted_1))
}
}

})